<template>
  <el-dialog
    top="50px"
    width="1200px"
    :title="action.name || ''"
    :visible="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @close="$emit('close')"
  >
    <ApproveForm
      :item="object"
      :disabled="true"
      :form="form"
      :update-fields="updateFields"
      :update-form="updateForm"
      :show-fields="showFields"
      :log-fields="logFields"
      :log-form="logForm"
      :config-modules="configModules"
    />
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        size="medium"
        @click="$emit('close')"
      >
        Đóng
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import ApproveForm from "@/components/items/ApproveForm.vue";

export default {
  name: "RequestHistoryPopup",
  components: {
    ApproveForm
  },
  props: {
    item: Object,
    documentData: Array,
    visible: Boolean,
  },
  data() {
    return {
      form: {
        notes: '',
      },
      updateForm: {},
      logForm: {},
    };
  },
  computed: {
    ...mapGetters("config", ["allConfigs"]),
    ...mapGetters("contract", ["allContractActions"]),
    action() {
      return this.allContractActions.find((a) => a.id === this.item.extra.action_id)
    },
    object() {
      return this.documentData.find((d) => d.id === this.item.extra.document_id)
    },
    config() {
      return this.allConfigs.find((c) => c.extra.key === this.object?.type)
    },
    fields() {
      return this.config?.extra?.fields || []
    },
    configContracts() {
      return this.config?.extra?.contracts || []
    },
    configModules() {
      return this.config?.extra?.modules || []
    },
    currentContract() {
      return this.configContracts.find((c) => c.contract_id === this.item.extra.contract_id)
    },
    configStep() {
      if (this.currentContract) {
        return this.currentContract.steps.find((s) => s.step_id === this.item.extra.action_step_id)
      }
      return {
        show_fields: [],
        update_fields: [],
        log_fields: []
      }
    },
    showFields() {
      return this.fields.filter((f) => this.configStep.show_fields.includes(f.key))
    },
    updateFields() {
      return this.fields.filter((f) => this.configStep.update_fields.includes(f.key))
    },
    logFields() {
      return this.configStep.log_fields
    },
  },
  beforeMount() {
    this.loadFormData();
  },
  methods: {
    loadFormData() {
      this.form = { notes: this.item.extra.notes };
      this.updateFields.forEach(field => {
        this.updateForm[field.key] = this.item.extra.extra_data.override[field.key];
      });
      this.logFields.forEach(field => {
        this.logForm[field.key] = this.item.extra.extra_data[field.key];
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
